






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Repeater extends Vue {
    @Prop() private count!: number;
}
